import { render, staticRenderFns } from "./LockersUsers .vue?vue&type=template&id=385e06a6&scoped=true&"
import script from "./LockersUsers .vue?vue&type=script&lang=ts&"
export * from "./LockersUsers .vue?vue&type=script&lang=ts&"
import style0 from "./LockersUsers .vue?vue&type=style&index=0&id=385e06a6&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "385e06a6",
  null
  
)

export default component.exports